module.exports = __webpack_public_path__ + "img/txt_keyvisual_mobile.5a9e885c.svg";